import React, { useState } from "react"
import { FormControl, MenuItem, Select, Slider } from "@mui/material";
import { useTranslation } from "react-i18next";

const FloorPlan: React.FunctionComponent<{ image: any, onEnhancedImage: any }> = (props) => {
    const { t } = useTranslation();
    const [selectStyle, setSelectStyle] = useState<any>("");

    const handleSelectStyle = (event: any) => {
        setSelectStyle(event.target.value)
    }

    const Generate = () => {
        props.onEnhancedImage(null);
    };

    return (
        <>
            <div className="card border-20">
                <div className="padd-20">
                    <h2 className="title-20 bold-700 color-black mb-4">{t("floorPlan.recommendationsTitle")}</h2>

                    <div className="form-check d-flex align-items-center mb-3">
                        <input className="form-check-input marg-right-10" type="checkbox" id="defaultCheck1" />
                        <label className="form-check-label-1" htmlFor="defaultCheck1">{t("floorPlan.recommendation1")}</label>
                    </div>
                    <div className="form-check d-flex align-items-center mb-3">
                        <input className="form-check-input marg-right-10" type="checkbox" id="defaultCheck2" />
                        <label className="form-check-label-1" htmlFor="defaultCheck2">{t("floorPlan.recommendation2")}</label>
                    </div>
                    <div className="form-check d-flex align-items-center mb-3">
                        <input className="form-check-input marg-right-10" type="checkbox" id="defaultCheck3" />
                        <label className="form-check-label-1" htmlFor="defaultCheck3">{t("floorPlan.recommendation3")}</label>
                    </div>
                    <div className="form-check d-flex align-items-center">
                        <input className="form-check-input marg-right-10" type="checkbox" id="defaultCheck4" />
                        <label className="form-check-label-1" htmlFor="defaultCheck4">{t("floorPlan.recommendation4")}</label>
                    </div>
                </div>
            </div>
            <div className="card border-20 mt-4">
                <div className="padd-20">
                    <h2 className="title-20 bold-700 color-black mb-4">{t("floorPlan.title")}</h2>
                    <div className="row">
                        <div className="col-10"></div>
                    </div>
                    <div className="d-flex justify-content-between gap-15 mb-4">
                        <FormControl fullWidth>
                            <Select
                                className="custom-select"
                                displayEmpty
                                inputProps={{ 'aria-label': 'Select' }}
                                value={selectStyle || ""}
                                onChange={handleSelectStyle}
                                sx={{
                                    border: "1px solid #746AFF",
                                    background: "#FFFFFF !important",
                                    color: "#746AFF",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#746AFF"
                                    },
                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#746AFF"
                                    }
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            backgroundColor: "#FFFFFF"
                                        }
                                    }
                                }}
                            >
                                <MenuItem value="" disabled> {t("floorPlan.selectStyle")} </MenuItem>
                                {/* Ajoutez ici d'autres styles si besoin */}
                            </Select>
                        </FormControl>
                        <button type="button" className={`button-dash back-trans color-746AFF height-48 width-48  border-746AFF padd-15 `}>
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 24.5C11.6892 24.5 11.3911 24.3765 11.1714 24.1568C10.9516 23.937 10.8281 23.6389 10.8281 23.3281V1.67188C10.8281 1.36107 10.9516 1.063 11.1714 0.843234C11.3911 0.623465 11.6892 0.5 12 0.5C12.3108 0.5 12.6089 0.623465 12.8286 0.843234C13.0484 1.063 13.1719 1.36107 13.1719 1.67188V23.3281C13.1719 23.6389 13.0484 23.937 12.8286 24.1568C12.6089 24.3765 12.3108 24.5 12 24.5Z" fill="#6366F1" />
                                <path d="M22.8281 13.6719H1.17188C0.861074 13.6719 0.563003 13.5484 0.343234 13.3286C0.123465 13.1089 0 12.8108 0 12.5C0 12.1892 0.123465 11.8911 0.343234 11.6714C0.563003 11.4516 0.861074 11.3281 1.17188 11.3281H22.8281C23.1389 11.3281 23.437 11.4516 23.6568 11.6714C23.8765 11.8911 24 12.1892 24 12.5C24 12.8108 23.8765 13.1089 23.6568 13.3286C23.437 13.5484 23.1389 13.6719 22.8281 13.6719Z" fill="#6366F1" />
                            </svg>
                        </button>
                    </div>
                    <div className="d-flex justify-content-end">
                        <button type="button" className={`button-dash back-746AFF color-FFFFFF bold-600 border-746AFF padd-15 width-100-100`} onClick={Generate}>
                            {t("floorPlan.generate")}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}
export default FloorPlan;